import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notFound">
           <div className="center">
           <p>
            PAGE NOT FOUND 
                
            </p> 
            <h1>
                404
            </h1>
           </div>
        </div>
    );
};

export default NotFound;